import { dispatchMetric } from '../metrics';
import { keys } from 'ramda';
import axios from 'axios';
import CONFIG from '../generated/config';
import { v4 } from 'uuid';
import { getPageLoadEventPayload } from '../metrics/metrics.selector';

function getSubmitStatus(errors) {
  for (var i in errors) {
    if (errors.hasOwnProperty(i)) {
      return 'error';
    }
  }
  return 'success';
}

export function dispatchSubmitEvent(state, errors) {
  const metricErrors = errors && {
    count: keys(errors).length,
    field: errors
  };

  dispatchMetric('form:submit', {
    errors: metricErrors,
    name: 'signup-' + state.customerType,
    status: getSubmitStatus(errors)
  });
}

export function dispatchRegisterCellPhoneMetrics() {
  dispatchMetric('phone:register-submit', {
    detail: {
      id: 'phone-register',
      optinwpp: 'ACCEPTED_OPTIN'
    }
  });
}

export function dispatchLoadEvent(pageType) {
  const metricPayload = {
    page: { type: pageType },
    payload: getPageLoadEventPayload(pageType)
  };

  dispatchMetric('page:load', metricPayload);

  axios({
    method: 'POST',
    url: CONFIG.api.streamsCollector,
    data: {
      brand: CONFIG.brand === 'prtl' ? 'aemp' : CONFIG.brand,
      data: {
        page: 'login',
        type: pageType,
        path: window.location.pathname,
        url: window.location.href
      },
      id: v4()
    }
  });
}
